import { Tag } from '../interface';

export const colorScheme = new Tag('light', 'color-scheme');
